import { ReactComponent as Trash } from "../../../assets/icons/trash.svg";
import { ReactComponent as Pencil } from "../../../assets/icons/pencil.svg";
import { ReactComponent as Eye } from "../../../assets/icons/eye.svg";
import { ReactComponent as Download } from "../../../assets/icons/download.svg";
import { Loading } from "../../../components/Loading/Loading";




export function ActionView({ onDelete, onEdit, isAdmin, onPreview, onDownload, isDownloading }: { onDelete: () => void, onEdit: () => void, isAdmin: boolean, onPreview: () => void, onDownload: () => void, isDownloading: boolean }) {
    return (
        <div className="z-10 w-[170px] bg-white shadow-[0_3px_20.5px_0_rgba(0,0,0,0.09)] rounded-[12px] mr-16 p-3">
            <ul className="text-xs" aria-labelledby="dropdownMenuIconButton">
                {/* <li onClick={onEdit} className="hover:bg-gray-100 p-3 cursor-pointer">Download</li> */}
                <li onClick={onPreview} className="hover:bg-gray-100 px-1.5 py-2 cursor-pointer rounded-[6px] flex items-center gap-3.5">
                    <Eye className="w-4 h-4 [&_path]:stroke-[#3F3F46]" />
                    Preview
                </li>
                <li onClick={onDownload} className="hover:bg-gray-100 px-1.5 py-2 cursor-pointer rounded-[6px] flex items-center gap-3.5">
                    <Download className="w-4 h-4 [&_path]:stroke-[#3F3F46]" />
                    Download
                    {isDownloading && <Loading />}
                </li>
                
                {isAdmin && <>
                    <li onClick={onEdit} data-testid="sales-aid-action-edit" className="hover:bg-gray-100 px-1.5 py-2 cursor-pointer rounded-[6px] flex items-center gap-3.5">
                        <Pencil className="w-4 h-4 [&_path]:stroke-[#3F3F46]" />
                        Edit
                    </li>
                    <>
                        <li className="px-1.5 py-1.5">
                            <div className="border-b border-[#E9E9E9] w-full" />
                        </li>
                        <li onClick={onDelete} className="hover:bg-gray-100 px-1.5 py-2 cursor-pointer rounded-[6px] flex items-center gap-3.5 text-[#DC2626]">
                            <Trash className="w-4 h-4 [&_path]:stroke-[#DC2626]" /> 
                            Delete
                        </li>
                    </>
                </>}
            </ul>
        </div>
    )
}